/* eslint-disable react-refresh/only-export-components */

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EsgTab } from '@/app/(client)/network/-components/companyProfileTabs/esgInformation/EsgTab';
import { useCompanyDetail } from '@/app/(client)/network/-hooks/useCompanyDetail';

const searchSchema = z.object({
  esgTemplate: z.string().optional(),
});

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/esg-info',
)({
  validateSearch: searchSchema,
  component: EsgInfoRoute,
});

function EsgInfoRoute() {
  const { companyId } = Route.useParams();
  const { data: company } = useCompanyDetail(companyId);
  return <EsgTab companyId={companyId} company={company} />;
}
